import React from 'react';

const WizardContentBox = ({ children, className = '' }) => {
  return <div className={`wizard-content-box ${className}`}>{children}</div>;
};

export default WizardContentBox;
